import App from './svelte/App.svelte';

const app = new App({
  target: document.body,
});

export default app;